<template>
  <div id="DiamondStock" :class="stoneType === 5 ? 'lab-grown' : ''">
    <section class="stock-text" :class="sMenu ? 'set-margin' : ''">
      <div class="container-md">
        <div class="row">
          <div class="col-1 p-0" v-if="!sMenu">
            <button
              class="arrow-left text-start"
              :disabled="navSite == 1 ? true : false"
              @click="changeSite(navSite - 1)"
            >
              &lt;
            </button>
          </div>
          <div
            class="text-center"
            :class="sMenu ? 'col' : 'col-10 col-md-8 offset-md-1'"
          >
            <h1 :class="sMenu ? '' : 'set-font ' + language" v-if="showMenu">
              {{ $t("DiamondStock.text.header") }}
            </h1>
            <h2 :class="sMenu ? '' : 'set-font ' + language" v-else>
              {{ $t("DiamondStock.text.header") }}
            </h2>
          </div>
          <div
            class="d-none d-md-inline-block col-md-1 page-select"
            v-if="!sMenu"
          >
            <select
              class="form-select"
              aria-label="Default select example"
              @change="changeSite()"
              v-model="navSite"
            >
              <option
                v-for="(site, index) in maxSites"
                v-bind:key="index"
                :selected="site == navSite"
                v-bind:value="site"
              >
                {{ site }}
              </option>
            </select>
          </div>
          <div class="col-1 p-0" v-if="!sMenu">
            <button
              class="arrow-right text-end"
              :disabled="navSite >= maxSites"
              @click="changeSite(navSite + 1)"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="stock-search-filter" v-if="sMenu">
      <div id="searchStockDiamond">
        <div class="container-md">
          <div
            class="row d-md-none d-lg-none d-xl-none d-xxl-none search-accordion"
          >
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#SearchForm"
                role="button"
                aria-expanded="false"
                aria-controls="StoneForm"
              >
                {{ $t("DiamondStock.search.form") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Carat"
                role="button"
                aria-expanded="false"
                aria-controls="Carat"
              >
                {{ $t("DiamondStock.search.carat") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Color"
                role="button"
                aria-expanded="false"
                aria-controls="Color"
              >
                {{ $t("DiamondStock.search.color") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Purity"
                role="button"
                aria-expanded="false"
                aria-controls="Purity"
              >
                {{ $t("DiamondStock.search.purity") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Finish"
                role="button"
                aria-expanded="false"
                aria-controls="Finish"
              >
                {{ $t("DiamondStock.search.finish") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Symmetry"
                role="button"
                aria-expanded="false"
                aria-controls="Symmetry"
              >
                {{ $t("DiamondStock.search.symmetry") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Polish"
                role="button"
                aria-expanded="false"
                aria-controls="Polish"
              >
                {{ $t("DiamondStock.search.polish") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Fluorescence"
                role="button"
                aria-expanded="false"
                aria-controls="Fluorescence"
              >
                {{ $t("DiamondStock.search.fluorescence") }}
              </a>
            </div>
            <div class="col-4 col-md-3 text-center">
              <a
                class="btn btn-sm"
                :class="
                  stoneType === 5
                    ? 'btn-outline-lab-grown'
                    : 'btn-outline-real-diamond-stock'
                "
                data-bs-toggle="collapse"
                href="#Price"
                role="button"
                aria-expanded="false"
                aria-controls="Price"
              >
                {{ $t("DiamondStock.search.price") }}
              </a>
            </div>
          </div>
          <div class="row main-search">
            <div
              class="col-12 col-md-5 text-center search-stock-stone-form collapse"
              id="SearchForm"
              data-bs-parent="#searchStockDiamond"
            >
              <div
                class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                data-bs-toggle="collapse"
                href="#SearchForm"
                role="button"
                aria-expanded="true"
                aria-controls="SearchForm"
              ></div>
              <p class="set-mb">{{ $t("DiamondStock.search.form") }}</p>
              <div class="d-md-none set-mb">
                {{ search.form.data[search.form.value] }}
              </div>
              <template
                v-for="(item, index) in search.form.data"
                v-bind:key="index"
              >
                <div class="stone-form" @change="searchStockDiamonds(1, true)">
                  <input
                    type="radio"
                    :id="index"
                    v-bind:value="index"
                    v-model="search.form.value"
                  />
                  <label :for="index" :title="item.split('-')[0]">
                    <img
                      :src="
                        appUrl +
                        '/img/assets/stones/forms/search/' +
                        index.toLowerCase() +
                        '.png'
                      "
                      class="rounded"
                      :alt="item"
                    />
                  </label>
                </div>
              </template>
            </div>
            <div class="col-12 col-md-7 text-center">
              <div class="row">
                <div
                  class="col-12 col-md-11 offset-md-1 text-center collapse"
                  id="Carat"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Carat"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Carat"
                  ></div>
                  <p>{{ $t("DiamondStock.search.carat") }}</p>
                  <vue-slider
                    v-model="search.carat.value"
                    :data="search.carat.marks"
                    :marks="search.carat.marks"
                    :tooltip="'none'"
                    :included="true"
                    :lazy="false"
                    :dot-attrs="{ 'aria-label': 'Größe/Gewicht' }"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
                <div
                  class="col-12 col-md-11 offset-md-1 text-center collapse"
                  id="Color"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Color"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Color"
                  ></div>
                  <p>{{ $t("DiamondStock.search.color") }}</p>
                  <vue-slider
                    v-model="search.color.value"
                    :data="search.color.data"
                    :marks="search.color.marks"
                    :dot-attrs="{ 'aria-label': 'Farbe' }"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
                <div
                  class="col-12 col-md-11 offset-md-1 text-center collapse"
                  id="Purity"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Purity"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Purity"
                  ></div>
                  <p>{{ $t("DiamondStock.search.purity") }}</p>
                  <vue-slider
                    v-model="search.purity.value"
                    :data="search.purity.data"
                    :marks="search.purity.marks"
                    :tooltip="'none'"
                    :dot-attrs="{ 'aria-label': 'Reinheit' }"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
              </div>
            </div>
          </div>
          <div class="row d-none d-md-block toggle-more-search">
            <div class="col-12 text-center">
              <a @click="toggleMoreSearch">
                {{ $t("DiamondStock.search.furtherOptions") }}
                <span>
                  <font-awesome-icon
                    :icon="
                      moreSearch
                        ? ['fas', 'chevron-circle-up']
                        : ['fas', 'chevron-circle-down']
                    "
                /></span>
              </a>
            </div>
          </div>
          <div
            class="row more-search"
            :class="moreSearch ? '' : 'd-flex d-md-none'"
          >
            <div class="col-12 col-md-5 text-center">
              <div class="row">
                <div
                  class="col-12 col-md-11 text-center collapse mb-md-4"
                  id="Finish"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Finish"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Finish"
                  ></div>
                  <p>{{ $t("DiamondStock.search.finish") }}</p>
                  <vue-slider
                    v-model="search.finish.value"
                    :data="search.finish.data"
                    :marks="search.finish.marks"
                    :dot-attrs="{ 'aria-label': 'Schliff' }"
                    :tooltip="'none'"
                    :disabled="search.finish.disable"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
                <div
                  class="col-12 col-md-11 text-center collapse mb-md-4"
                  id="Symmetry"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Symmetry"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Symmetry"
                  ></div>
                  <p>{{ $t("DiamondStock.search.symmetry") }}</p>
                  <vue-slider
                    v-model="search.symmetry.value"
                    :data="search.symmetry.data"
                    :marks="search.symmetry.marks"
                    :dot-attrs="{ 'aria-label': 'Symmetrie' }"
                    :tooltip="'none'"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
                <div
                  class="col-12 col-md-11 text-center collapse px-0"
                  id="Price"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Price"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Price"
                  ></div>
                  <p class="form-label pb-2">
                    {{ $t("DiamondStock.search.priceX") }}
                  </p>
                  <select
                    class="form-select"
                    @change="searchStockDiamonds(1, true)"
                    v-model="search.price.value"
                  >
                    <option
                      v-for="(price, index) in search.price.data"
                      v-bind:key="index"
                      :selected="price == search.price.value"
                      v-bind:value="index"
                    >
                      {{ price }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-7 text-center">
              <div class="row">
                <div
                  class="col-12 col-md-11 offset-md-1 text-center collapse mb-md-4"
                  id="Polish"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Polish"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Polish"
                  ></div>
                  <p>{{ $t("DiamondStock.search.polish") }}</p>
                  <vue-slider
                    v-model="search.polish.value"
                    :data="search.polish.marks"
                    :marks="search.polish.marks"
                    :included="true"
                    :lazy="false"
                    :dot-attrs="{ 'aria-label': 'Politur' }"
                    :tooltip="'none'"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
                <div
                  class="col-12 col-md-11 offset-md-1 text-center collapse mb-md-4"
                  id="Fluorescence"
                  data-bs-parent="#searchStockDiamond"
                >
                  <div
                    class="btn btn-close d-md-none d-lg-none d-xl-none d-xxl-none text-end"
                    data-bs-toggle="collapse"
                    href="#Fluorescence"
                    role="button"
                    aria-expanded="true"
                    aria-controls="Fluorescence"
                  ></div>
                  <p>{{ $t("DiamondStock.search.fluorescence") }}</p>
                  <vue-slider
                    v-model="search.fluorescence.value"
                    :data="search.fluorescence.marks"
                    :marks="search.fluorescence.marks"
                    :included="true"
                    :lazy="false"
                    :dot-attrs="{ 'aria-label': 'Fluoreszenz' }"
                    :tooltip="'none'"
                    @change="searchStockDiamonds(1, true)"
                    class="set-vue-slider"
                  ></vue-slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="certificate-search" :class="'search-' + language">
        <div class="container-fluid p-0">
          <div class="container-md p-0">
            <div class="row">
              <div
                :class="
                  maxSites > 0
                    ? 'col-4 col-md-3 col-lg-2 text-center'
                    : 'col-6 col-md-5 text-center'
                "
              >
                <div class="form-label">
                  {{ $t("DiamondStock.search.certificate") }}
                </div>
                <div class="d-flex flex-wrap certificate-switches">
                  <div
                    class="form-check form-switch d-flex flex-column align-items-center m-0"
                    v-for="(item, key) in search.certificate.data"
                    v-bind:key="key"
                  >
                    <input
                      class="form-check-input mx-0"
                      type="checkbox"
                      role="switch"
                      :value="key"
                      :name="item.toLowerCase()"
                      v-model="search.certificate.value"
                      :id="item"
                      @change="searchStockDiamonds(1, true)"
                    />
                    <label
                      class="form-check-label mt-1 mt-sm-0 ms-1 ms-sm-0"
                      :for="item"
                    >
                      {{ item }}
                    </label>
                  </div>
                </div>
              </div>
              <div
                :class="
                  maxSites > 0
                    ? 'col-4 col-sm-5 col-md-6 offset-lg-1 text-center'
                    : 'col-6 col-md-7 text-center'
                "
              >
                <label class="form-label">
                  {{ $t("DiamondStock.search.certificateNo") }}
                  <span class="d-none d-sm-inline" v-if="shopId > 10000">
                    / {{ $t("DiamondStock.search.supplier") }}
                  </span>
                </label>
                <input
                  type="number"
                  v-model.number.trim="search.certificateNo"
                  @change="searchStockDiamonds(1, true)"
                  class="form-control"
                />
              </div>
              <div
                :class="
                  maxSites > 0
                    ? 'col-3 col-sm-2 offset-1 text-center'
                    : 'd-none'
                "
              >
                <div class="row">
                  <div class="d-none col-3 offset-1 col-sm-4 d-md-none">
                    <button
                      class="arrow-left text-end"
                      :disabled="navSite == 1 ? true : false"
                      @click="changeSite(navSite - 1)"
                    >
                      &lt;
                    </button>
                  </div>
                  <div class="col-12 page-select">
                    <label class="form-label">
                      {{ $t("DiamondStock.search.page") }}
                    </label>
                    <select
                      class="form-select"
                      @change="changeSite()"
                      v-model="navSite"
                    >
                      <option
                        v-for="(site, index) in maxSites"
                        v-bind:key="index"
                        :selected="site == navSite"
                        v-bind:value="site"
                      >
                        {{ site }}
                      </option>
                    </select>
                  </div>
                  <div class="d-none col-3 col-sm-4 d-md-none">
                    <button
                      class="arrow-right text-start"
                      :disabled="navSite >= maxSites ? true : false"
                      @click="changeSite(navSite + 1)"
                    >
                      &gt;
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loading === true" />
    <div class="stock-diamond-list" v-else>
      <template v-if="diamondStock.quantity > 0">
        <div
          class="container-fluid diamond-data"
          v-for="(item, diamondId, index) in diamondStock.list"
          v-bind:key="diamondId"
        >
          <div class="container-md p-0">
            <div class="row">
              <div class="col-3 col-sm-2 img-col text-center" :data="diamondId">
                <router-link
                  :to="{
                    name: 'diamond-data',
                    params: { diamondId: diamondId.split('_')[1] },
                  }"
                >
                  <p
                    class="carat"
                    :class="
                      item.stone_type == 5 ? 'lab-grown-bg' : 'real-diamond-bg'
                    "
                  >
                    {{ item.stone_size }} ct.
                  </p>
                  <img
                    :src="
                      appUrl +
                      '/img/assets/stones/forms/600/' +
                      (index % 2 ? 'grey' : 'white') +
                      '/' +
                      (item.picture == 'q' ? 'f' : item.picture) +
                      '.jpg'
                    "
                    class="rounded"
                  />
                </router-link>
              </div>
              <div class="col-6 offset-sm-1 col-md-7 data-col">
                <div class="row">
                  <div class="col-12 col-md-6 form">
                    <p class="row">
                      <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                        {{ $t("DiamondStock.table.form") }}:
                      </span>
                      <span
                        class="col-7 col-sm-8 col-md-7 col-lg-8 value"
                        v-if="item.stoneform !== false"
                      >
                        {{ item.stoneform.split("-")[0] }}</span
                      >
                    </p>
                  </div>
                  <div class="col-12 col-md-6 color">
                    <p class="row">
                      <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                        {{ $t("DiamondStock.table.color") }}:
                      </span>
                      <span class="col-7 col-sm-8 col-md-7 col-lg-8 value">
                        {{ item.color.split("-")[0] }}
                        <template
                          class="d-none d-sm-inline d-md-none d-lg-inline"
                        >
                          - {{ item.color.split("-")[1] }}
                        </template>
                      </span>
                    </p>
                  </div>
                  <div class="col-12 col-md-6 purity">
                    <p class="row">
                      <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                        {{ $t("DiamondStock.table.purity") }}:
                      </span>
                      <span class="col-7 col-sm-8 col-md-7 col-lg-8 value">
                        {{ item.purity.split("-")[0] }}
                        <template
                          class="d-none d-sm-inline d-md-none d-lg-inline"
                        >
                          - {{ item.purity.split("-")[1] }}
                        </template>
                      </span>
                    </p>
                  </div>
                  <div
                    class="col-12 col-md-6 finish"
                    v-if="search.form.value === 'A'"
                  >
                    <p class="row">
                      <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                        {{ $t("DiamondStock.table.finish") }}:
                      </span>
                      <span class="col-7 col-sm-8 col-md-7 col-lg-8 value">
                        {{ item.finish }}
                      </span>
                    </p>
                  </div>
                  <div class="col-12 col-md-6 certificate-data">
                    <p class="row">
                      <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                        {{ $t("DiamondStock.table.certificate") }}:
                      </span>
                      <span class="col-7 col-sm-8 col-md-7 col-lg-8 value">
                        <template
                          v-if="
                            item.certificateNr && item.certificate_id === '1'
                          "
                        >
                          <a
                            :href="
                              'https://www.gia.edu/report-check?reportno=' +
                              item.certificateNr
                            "
                            class="text-decoration-underline"
                            target="_blank"
                          >
                            {{ item.certificate }}
                            <template class="d-none d-sm-inline">
                              -
                              {{ item.certificateNr.split(" ")[0] }}</template
                            >
                          </a>
                        </template>
                        <template
                          v-else-if="
                            item.certificateNr && item.certificate_id === '2'
                          "
                        >
                          <a
                            :href="
                              'https://www.igi.org/verify-your-report/?r=' +
                              (item.certificateNr
                                ? item.certificateNr.replace(/\s+/g, '')
                                : '')
                            "
                            class="text-decoration-underline"
                            target="_blank"
                          >
                            {{ item.certificate }}
                            <template class="d-none d-sm-inline">
                              - {{ item.certificateNr }}</template
                            >
                          </a>
                        </template>
                        <template
                          v-else-if="
                            item.certificateNr && item.certificate_id === '3'
                          "
                        >
                          {{ item.certificate }}
                          <template class="d-none d-sm-inline fw-bold">
                            - {{ item.certificateNr }}</template
                          >
                        </template>
                        <template v-else>
                          {{ item.certificate }}
                          <span
                            class="d-none d-sm-inline d-md-none d-lg-inline"
                          >
                            - {{ $t("DiamondStock.text.recommend") }}</span
                          >
                        </template>
                        <template v-if="item.stone_type === '5'">
                          <span class="d-md-none fw-bold">
                            ({{ $t("DiamondStock.table.lab") }})</span
                          >
                        </template>
                      </span>
                    </p>
                  </div>
                  <template v-if="item.stone_type === '5'">
                    <div class="col-12 col-md-6 lab-grown d-none d-md-block">
                      <p class="row">
                        <span class="col-5 col-sm-4 col-md-5 col-lg-4 text">
                          {{ $t("DiamondStock.table.labGrown") }}:
                        </span>
                        <span class="col-7 col-sm-8 col-md-7 col-lg-8 value">
                          {{ $t("DiamondStock.table.yes") }}</span
                        >
                      </p>
                    </div>
                  </template>
                </div>
              </div>
              <div
                class="col-3 offset-sm-1 col-sm-2 offset-md-0 more-col text-center"
              >
                <div class="row">
                  <div class="col-12 col-md-4 wish-list">
                    <span
                      class="wish-list-toggle-icon"
                      :class="item.stone_type == 5 ? 'wish-list-lab-grown' : ''"
                      :ref="'WishList-' + diamondId"
                      @click="toggleWishList(diamondId)"
                    >
                      <template v-if="isOnWishList[diamondId]"
                        >&#9829;</template
                      >
                      <template v-else>&#9825;</template>
                    </span>
                  </div>
                  <div class="col-12 col-md-8 price">
                    <span class="value fw-bold brand-color">
                      {{ $n(parseFloat(item.cachePrice), "currency") }}
                    </span>
                  </div>
                  <div class="col-12 more-infos">
                    <router-link
                      :to="{
                        name: 'diamond-data',
                        params: { diamondId: diamondId.split('_')[1] },
                      }"
                      class="btn btn-sm btn-block"
                      :class="
                        item.stone_type == 5
                          ? 'btn-outline-lab-grown'
                          : 'btn-outline-real-diamond-stock'
                      "
                    >
                      {{ $t("DiamondStock.table.more") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="container-md" v-else>
        <div class="row">
          <div class="col empty text-center">
            {{ $t("DiamondStock.empty") }}
          </div>
        </div>
      </div>
      <div class="container-md">
        <div class="row">
          <div
            :class="
              maxSites > 0 || search.stoneIds.value === true
                ? 'col-6 offset-3 col-md-3 offset-md-9 show-fav pe-md-0'
                : 'd-none'
            "
          >
            <button @click="openWishlist" class="btn btn-grey">
              <template v-if="!search.stoneIds.value">
                {{ $t("DiamondStock.stoneIds.open") }}
              </template>
              <template v-if="search.stoneIds.value">
                {{ $t("DiamondStock.stoneIds.close") }}
              </template>
              <span> &#9829;</span>
            </button>
          </div>
        </div>
        <div class="row" v-if="maxSites > 0">
          <div class="col-12 text-center">
            <nav class="diamond-nav" aria-label="page navigation">
              <ul class="pagination justify-content-center">
                <li class="page-item" :class="{ disabled: navSite == 1 }">
                  <a
                    class="page-link"
                    @click="changeSite(navSite - 1)"
                    tabindex="-1"
                    >&lt;&lt;</a
                  >
                </li>
                <li
                  class="page-item"
                  v-for="(site, index) in sites"
                  v-bind:key="index"
                  :class="{ active: site == navSite }"
                >
                  <a class="page-link" @click="changeSite(site)">{{ site }}</a>
                </li>
                <li
                  class="page-item"
                  :class="{ disabled: navSite == maxSites }"
                >
                  <a class="page-link" @click="changeSite(navSite + 1)">
                    &gt;&gt;
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/SpinnerLoader.vue";
import DAODiamondStock from "@/assets/DAO/DiamondStock";
import DAOWishList from "@/assets/DAO/WishList";
import WishListDTO from "@/assets/WishListDTO";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

import { computed, onMounted, reactive, ref, watchEffect } from "vue";
import store from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronCircleUp } from "@fortawesome/free-solid-svg-icons";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronCircleDown);
library.add(faChevronCircleUp);

export default {
  name: "diamond-stock",
  components: {
    Loader,
    VueSlider,
    // eslint-disable-next-line vue/no-unused-components
    DAOWishList,
    // eslint-disable-next-line vue/no-unused-components
    WishListDTO,
    FontAwesomeIcon,
  },
  props: {
    showMenu: {
      type: Boolean,
    },
    sType: {
      required: true,
    },
    stockSearch: {
      type: Object,
    },
  },
  setup(props) {
    const sMenu = ref(props.showMenu);
    const moreSearch = ref(
      store.getters["setSearchData/getMoreSearch"]
        ? store.getters["setSearchData/getMoreSearch"]
        : false
    );
    const navLimit = ref(15);
    const navSite = ref(
      store.getters["setSearchData/getNavSite"] > 0
        ? store.getters["setSearchData/getNavSite"]
        : 1
    );
    const navPlaceholder = ref("...");
    const loading = ref(true);
    const isOnWishList = ref({});
    const stoneType = ref(props.sType);
    const search = reactive({
      form: {
        value: setSearch("form"),
        data: [],
      },
      carat: {
        value: setSearch("carat"),
        data: [],
        marks: [
          "0.3",
          "0.4",
          "0.5",
          "0.7",
          "1.0",
          "1.5",
          "2.0",
          "3.0",
          "4.0",
          "5.0",
        ],
      },
      color: {
        value: setSearch("color"),
        data: [],
        marks: [],
      },
      finish: {
        value: setSearch("finish"),
        data: [],
        disable: false,
      },
      purity: {
        value: setSearch("purity"),
        data: [],
        marks: [],
      },
      polish: {
        value: setSearch("polish"),
        data: [],
        marks: [],
      },
      symmetry: {
        value: setSearch("symmetry"),
        data: [],
        marks: [],
      },
      fluorescence: {
        value: setSearch("fluorescence"),
        data: [],
        marks: [],
      },
      price: {
        value: setSearch("price"),
        data: [],
      },
      certificate: {
        value: setSearch("certificate"),
        data: [],
      },
      stoneIds: {
        value: setSearch("stoneIds"),
        data: [],
      },
      certificateNo: setSearch("certificateNo"),
    });

    const diamondStock = reactive({
      listType: ref(0),
      list: ref({}),
      quantity: ref(0),
      search: ref(search),
    });
    const maxSites = computed(() =>
      Math.ceil(diamondStock.quantity / navLimit.value)
    );
    const sites = computed(() => {
      let sites = [];
      let max = maxSites.value;
      let min = 1;
      let mid = 2;

      for (let i = 1; i <= max; i++) {
        if (
          i <= min ||
          i > max - min ||
          (i >= navSite.value - mid && i <= navSite.value + mid)
        ) {
          sites.push(i);
        }
      }

      for (let i in sites) {
        i = parseInt(i);
        if (typeof sites[i + 1] !== "undefined") {
          if (
            sites[i] + 1 !== sites[i + 1] &&
            sites[i] !== navPlaceholder.value
          ) {
            sites.splice(i + 1, 0, navPlaceholder.value);
          }
        }
      }

      return sites;
    });

    function setSearch(index) {
      let value = "";
      let dSearch = props.stockSearch;

      if (
        typeof dSearch[index] !== "undefined" &&
        dSearch[index] !== null &&
        dSearch[index] !== ""
      ) {
        if (index === "certificate" && typeof dSearch[index] === "string") {
          value = dSearch[index].split("-");
        } else {
          value = dSearch[index];
        }
      }

      if (index === "stoneIds" && value === "") {
        value = false;
      }

      return value;
    }

    function openWishlist() {
      search.stoneIds.value = !search.stoneIds.value;
      store.dispatch("setSearchData/setStoneIds", search.stoneIds.value);
      searchStockDiamonds(1, true, true);
    }

    function searchStockDiamonds(
      nPage = 1,
      isNewSearch = false,
      showWishList = false
    ) {
      loading.value = true;

      if (nPage > 1 || isNewSearch === true) {
        navSite.value = isNewSearch ? 1 : nPage;
      } else {
        navSite.value =
          store.getters["setSearchData/getNavSite"] > 0
            ? store.getters["setSearchData/getNavSite"]
            : 1;
      }

      if (showWishList === false && search.stoneIds.value === true) {
        search.stoneIds.value = !search.stoneIds.value;
      }

      if (search.stoneIds.value === true) {
        store.dispatch("setSearchData/setNavSite", navSite.value);
        getWishList().then(() => {
          getStockDiamonds();
        });
      } else {
        getStockDiamonds();
      }
    }

    function getStockDiamonds() {
      setTimeout(() => {
        DAODiamondStock.getList(
          store.getters["config/getCountry"],
          search.carat.value,
          search.color.value,
          search.finish.value,
          search.polish.value,
          search.purity.value,
          search.form.value,
          search.symmetry.value,
          search.fluorescence.value,
          search.price.value,
          search.certificateNo,
          search.certificate.value.join("-"),
          search.stoneIds.value === true ? search.stoneIds.data : false,
          stoneType.value,
          navSite.value,
          navLimit.value
        ).then((response) => {
          diamondStock.list = response.list;
          diamondStock.search = response.search;
          diamondStock.quantity = response.diamonds_found;

          for (let id in diamondStock.list) {
            isDiamondInWishList(id);
          }

          for (let [key, item] of Object.entries(response.form)) {
            let sKey = key.split("_")[0];
            let dataLength = Object.keys(item).length;

            if (sKey === "color" || sKey === "purity") {
              let data = {};
              let marks = {};

              for (const [key, value] of Object.entries(item)) {
                let d = value.split("-");
                marks[key] = d[0];
                data[key] = d[1];
              }

              search[sKey]["data"] = data;
              search[sKey]["marks"] = marks;

              if (
                search[sKey]["value"][1] === "" ||
                search[sKey]["value"][1] === undefined
              ) {
                search[sKey]["value"] = [
                  search[sKey]["value"][0],
                  Object.keys(item)[dataLength - 1],
                ];
              }
            } else if (
              sKey === "finish" ||
              sKey === "polish" ||
              sKey === "symmetry" ||
              sKey === "fluorescence"
            ) {
              search[sKey]["data"] = item;
              search[sKey]["marks"] = item;

              if (
                search[sKey]["value"][1] === "" ||
                search[sKey]["value"][1] === undefined
              ) {
                search[sKey]["value"] = [
                  search[sKey]["value"][0],
                  Object.keys(item)[dataLength - 1],
                ];
              }
            } else if (sKey === "stoneform") {
              search["form"]["data"] = item;

              if (
                search["form"]["value"] === "" ||
                search["form"]["value"] === undefined
              ) {
                search["form"]["value"] = response.search[key].from;
              }

              if (response.search[key].from !== "A") {
                search["finish"]["disable"] = true;
              } else {
                search["finish"]["disable"] = false;
              }
            } else if (sKey === "certificate") {
              search[sKey]["data"] = item;
              search[sKey]["value"] = response.search[key].split("-");
            } else if (sKey === "price") {
              //delete item[400000];
              search[sKey]["data"] = item;

              if (
                search[sKey]["value"] === "" ||
                search["form"]["value"] === undefined
              ) {
                search[sKey]["value"] = response.search[key].from;
              }
            }
          }

          loading.value = false;
        });
      }, 0);
    }

    function toggleMoreSearch() {
      moreSearch.value = !moreSearch.value;
      store.dispatch("setSearchData/setMoreSearch", moreSearch.value);
    }

    function toggleWishList(id) {
      WishListDTO.toggleDiamond(id).then(async (result) => {
        isOnWishList.value[id] = result === true ? result : false;
        await getWishList();
      });
    }

    function isDiamondInWishList(id) {
      DAOWishList.getDiamond(id).then((result) => {
        isOnWishList.value[id] = result !== false;
      });
    }

    function getWishList() {
      search.stoneIds.data = {};
      return DAOWishList.getAll("diamonds").then((result) => {
        if (typeof result === "object" && result.length > 0) {
          for (let numericKey in result) {
            search.stoneIds.data["'" + result[numericKey].id + "'"] = result[
              numericKey
            ].id.replace("id_", "");
          }
        }
      });
    }

    const changeSite = (newSite = navSite.value) => {
      if (newSite !== navPlaceholder.value) {
        if (newSite < 0) {
          newSite.value = 0;
        } else {
          let maxSite = maxSites.value;
          navSite.value = maxSite < newSite ? maxSite : newSite;
        }

        store.dispatch("setSearchData/setNavSite", navSite.value);
        searchStockDiamonds(navSite.value);
      }
    };

    watchEffect(() => {
      if (sMenu.value === true) {
        let storeSearch = {};

        for (const [key, value] of Object.entries(search)) {
          storeSearch[key] = key === "certificateNo" ? value : value.value;
        }

        store.dispatch("setSearchData/setDiamondStockSearch", storeSearch);
      }
    });

    onMounted(() => {
      searchStockDiamonds();
    });

    return {
      appUrl: computed(() => store.getters["config/getAppUrl"]),
      shopId: computed(() => store.getters["config/getActiveShop"]),
      language: computed(() => store.getters["config/getLanguage"]),
      sMenu,
      search,
      stoneType,
      sites,
      navSite,
      maxSites,
      loading,
      diamondStock,
      moreSearch,
      isOnWishList,
      openWishlist,
      changeSite,
      searchStockDiamonds,
      toggleMoreSearch,
      toggleWishList,
    };
  },
};
</script>

<style lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.vue-slider {
  &.vue-slider-disabled {
    .vue-slider-rail,
    .vue-slider-process {
      background-color: $vueSliderLightGreyColor;
    }

    .vue-slider-dot {
      .vue-slider-dot-handle {
        background-color: $vueSliderLightGreyColor;

        &.vue-slider-dot-handle-focus,
        &.vue-slider-dot-handle-disabled {
          border-color: $vueSliderLightGreyColor !important;

          &:hover {
            background-color: $vueSliderLightGreyColor;
          }
        }
      }
    }

    .vue-slider-marks {
      .vue-slider-mark {
        .vue-slider-mark-step {
          box-shadow: 0 0 0 2px $vueSliderLightGreyColor;

          &.vue-slider-mark-step-active {
            box-shadow: 0 0 0 2px $vueSliderLightGreyColor;
          }
        }
      }
    }

    &:hover {
      .vue-slider-rail,
      .vue-slider-process {
        background-color: $vueSliderLightGreyColor;
      }

      .vue-slider-dot-handle {
        background-color: $vueSliderLightGreyColor;
        border-color: $vueSliderLightGreyColor;

        .vue-slider-dot-handle-focus {
          border-color: $vueSliderLightGreyColor;
          background-color: $vueSliderLightGreyColor;
        }
      }
    }
  }

  .vue-slider-rail {
    background-color: $vueSliderGreyColor;
  }

  .vue-slider-process {
    background-color: $vueSliderDarkGreyColor;
  }

  .vue-slider-dot {
    width: 16px !important;
    height: 16px !important;

    .vue-slider-dot-handle {
      background-color: $vueSliderDarkGreyColor;
      border-color: $vueSliderDarkGreyColor;

      &.vue-slider-dot-handle-focus {
        box-shadow: none;
        border-color: $vueSliderDarkGreyColor;
      }
    }

    .vue-slider-dot-tooltip-inner {
      background-color: $vueSliderDarkGreyColor;

      &:after {
        border-top-color: $vueSliderDarkGreyColor;
      }
    }
  }

  .vue-slider-marks {
    .vue-slider-mark {
      .vue-slider-mark-step {
        box-shadow: 0 0 0 2px $vueSliderGreyColor;

        &.vue-slider-mark-step-active {
          box-shadow: 0 0 0 2px $vueSliderDarkGreyColor;
        }
      }

      .vue-slider-mark-label {
        font-size: 1rem;

        @media #{$sm} {
          font-size: 1.2rem;
        }
      }
    }
  }

  &:hover {
    .vue-slider-rail {
      background-color: $vueSliderGreyColor;
    }

    .vue-slider-process {
      background-color: $vueSliderDarkGreyColor;
    }

    .vue-slider-dot-handle {
      box-shadow: none;
      border-color: $vueSliderDarkGreyColor;
      background-color: $vueSliderDarkGreyColor;

      .vue-slider-dot-handle-focus {
        box-shadow: none;
        border-color: $vueSliderDarkGreyColor;
        background-color: $vueSliderDarkGreyColor;
      }
    }
  }
}

.lab-grown {
  .vue-slider {
    .vue-slider-process {
      background-color: $labGrownColor;
    }

    .vue-slider-dot {
      .vue-slider-dot-handle {
        background-color: $labGrownColor;
        border-color: $labGrownColor;

        &.vue-slider-dot-handle-focus {
          border-color: $labGrownColor;
        }
      }

      .vue-slider-dot-tooltip-inner {
        background-color: $labGrownColor;

        &:after {
          border-top-color: $labGrownColor;
        }
      }
    }

    .vue-slider-marks {
      .vue-slider-mark {
        .vue-slider-mark-step {
          &.vue-slider-mark-step-active {
            box-shadow: 0 0 0 2px $labGrownColor;
          }
        }
      }
    }

    &:hover {
      .vue-slider-process {
        background-color: $labGrownColor;
      }

      .vue-slider-dot-handle {
        border-color: $labGrownColor;
        background-color: $labGrownColor;

        .vue-slider-dot-handle-focus {
          border-color: $labGrownColor;
          background-color: $labGrownColor;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#DiamondStock {
  min-height: 185rem;

  @media (min-width: 375px) {
    min-height: 195rem;
  }

  @media #{$md} {
    min-height: 155rem;
  }

  @media #{$md} {
    min-height: 160rem;
  }

  .more-infos {
    .btn {
      max-width: 100% !important;
    }
  }

  .stock-text {
    margin-bottom: 1rem;
    background-color: #f0f0f0;
    border-top: 0.1rem solid $greyColor;
    border-bottom: 0.1rem solid $greyColor;

    &.set-margin {
      margin-bottom: 2.5rem;
    }

    h1 {
      padding: 0;
      margin: 2rem 0;

      &.set-font {
        &.de {
          @media (max-width: 329px) {
            font-size: 1.2rem;
          }
        }

        &.nl {
          @media (max-width: 389px) {
            font-size: 1.2rem;
          }

          @media (max-width: 364px) {
            font-size: 1.1rem;
          }

          @media (max-width: 339px) {
            font-size: 1rem;
          }
        }
      }

      @media (max-width: 374px) {
        font-size: 1.6rem;
        line-height: 1.8rem;
      }
    }

    h2 {
      padding: 0;
      margin: 2rem 0;
      font-size: 1.6rem;
      line-height: 1.8rem;

      @media #{$sm} {
        font-size: 2rem;
        line-height: 2.2rem;
      }
    }

    .arrow-left,
    .arrow-right {
      width: 100%;
      color: #333;
      border: none;
      background: none;
      font-size: 2.5rem;
      padding: 1rem 0;

      &:disabled {
        color: #aaa;
      }

      @media (max-width: 374px) {
        font-size: 2.4rem;
        padding: 0.4rem 0;
      }

      @media #{$sm} {
        font-size: 3rem;
        padding: 0.75rem 0;
      }
    }

    .page-select {
      margin: 0.5rem 0;
      padding: 0.75rem 0 0;

      &:hover,
      &:focus,
      &:checked {
        border: none;
      }
    }
  }

  .stock-search-filter {
    & > p {
      font-size: 1.25rem;
    }

    .search-accordion {
      padding-bottom: 1.5rem;

      .btn {
        padding: 0.5rem 1rem;
        margin-bottom: 1rem;
        font-weight: normal;

        &[aria-expanded="true"] {
          color: #fff !important;
          font-weight: bold !important;
          background-color: $realDiamondColor;

          @media (max-width: 767px) {
            font-size: 1.2rem;
          }

          @media (max-width: 400px) {
            font-size: 1.05rem;
          }
        }

        &.collapsed {
          color: #333;
          font-weight: normal;
          background-color: #fff;
          text-transform: capitalize;
        }

        @media (max-width: 767px) {
          font-size: 1.3rem;
        }

        @media (max-width: 400px) {
          font-size: 1.1rem;
        }
      }

      @media #{$sm} {
        padding-bottom: 0;
      }
    }

    .search-stock-stone-form {
      p {
        &.set-mb {
          margin-bottom: 0 !important;

          @media #{$md} {
            margin-bottom: 0.5rem !important;
          }
        }
      }

      div {
        &.set-mb {
          margin-bottom: 1.5rem;
        }
      }

      .stone-form {
        margin: 0.5rem;
        display: inline-block;
        width: calc(20% - 1rem);

        input[type="radio"] {
          display: none;

          &:checked + label {
            padding: 0.15rem;
            border: 0.2rem solid $vueSliderDarkGreyColor;
          }

          &:hover,
          &:active,
          &:focus {
            label {
              cursor: pointer;
              box-shadow: none;
            }
          }
        }

        label {
          padding: 0.25rem;
          border-radius: 5%;
          position: relative;
          text-align: center;
          border: 0.1rem solid $vueSliderDarkGreyColor;

          img {
            width: 100%;
            max-width: 3rem;
            cursor: pointer;

            @media #{$sm} {
              max-width: 4rem;
            }

            @media #{$lg} {
              max-width: 5rem;
            }
          }

          @media #{$sm} {
            padding: 0.05rem;
          }

          @media #{$md} {
            padding: 0.25rem;
          }
        }

        @media #{$sm} {
          width: calc(10% - 1rem);
        }

        @media #{$md} {
          margin: 0.75rem;
          width: calc(25% - 2rem);
        }

        @media #{$lg} {
          margin: 1rem;
        }

        @media #{$xl} {
          //width: calc(20% - 2rem);
        }
      }
    }

    .toggle-more-search {
      margin-top: 2rem;
      padding-top: 2rem;
      border-top: 0.1rem dashed $greyColor;

      a {
        color: #333;
        cursor: pointer;
        font-weight: 500;
        font-size: 1.6rem;

        span {
          margin-left: 0.5rem;
          color: $realDiamondColor;
        }
      }
    }

    .certificate-search {
      padding: 0.75rem;
      background: #f0f0f0;
      border-top: 0.1rem solid $greyColor;
      border-bottom: 0.1rem solid $greyColor;

      & > .row {
        @media #{$xxl} {
          max-width: 132rem;
          margin: auto;
        }
      }
      &.search-nl {
        .form-label {
          font-weight: normal;

          @media (max-width: 415px) {
            font-weight: bolder;
          }
        }

        @media (max-width: 415px) {
          font-size: 1.3rem;
        }

        @media (max-width: 385px) {
          font-size: 1.2rem;
        }

        @media (max-width: 360px) {
          font-size: 1.1rem;
        }

        @media (max-width: 335px) {
          font-size: 1rem;
        }
      }

      .certificate-switches {
        row-gap: 0;
        justify-content: space-between;

        @media (max-width: 364px) {
          column-gap: 1.5rem;
          justify-content: center;
        }
      }

      .form-check {
        .form-check-input,
        .form-control,
        .form-select {
          &:hover,
          &:focus,
          &:active {
            border: none;
            box-shadow: none;
          }
        }

        &.form-switch {
          padding-left: 0;

          .form-check-input {
            width: 2em;
            height: 1em;
            margin-top: 0;
            margin-left: 0;

            @media #{$sm} {
              width: 2.5em;
            }

            @media #{$lg} {
              width: 2.75em;
            }
          }

          .form-check-input {
            &:checked {
              border-color: $realDiamondColor;
              background-color: $realDiamondColor;

              &:focus {
                background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
              }
            }

            &:focus {
              background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e");
            }
          }
        }

        @media (min-width: 540px) {
          margin-top: 0.25rem;
        }
      }

      .form-control,
      .form-select {
        font-size: 1rem;

        @media #{$sm} {
          font-size: 1.3rem;
        }
      }

      .form-control {
        margin: auto;
        max-width: 14rem;

        @media #{$sm} {
          max-width: 20rem;
        }

        @media #{$md} {
          max-width: 25rem;
        }
      }

      .form-select {
        margin: auto;

        @media #{$sm} {
          max-width: 100%;
        }
      }

      @media #{$sm} {
        margin-top: 2rem;
      }

      @media #{$md} {
        padding: 1.5rem 0;
      }
    }

    .more-search {
      display: flex;

      &.hidden {
        @media #{$md} {
          display: none;
        }
      }

      .form-select {
        width: 90%;
        margin: auto 5%;

        @media #{$md} {
          width: 100%;
          margin: auto;
        }
      }

      @media #{$md} {
        margin: 2rem 0 4rem;
      }
    }

    .main-search,
    .more-search {
      bottom: 0;
      width: 100%;
      z-index: 1000;
      position: fixed;
      background: #fff;

      p {
        padding: 0;
        font-size: 2rem;
        margin: -1rem 0 1.5rem;

        @media #{$md} {
          padding: initial;
          font-size: 1.4rem;
          margin: 0 0 0.5rem;
        }
      }

      .btn-close {
        top: 2%;
        right: -48%;
        position: absolute;
      }

      .collapse {
        &.show {
          padding: 2rem 2rem 4rem;
          border-top: 0.15rem solid $greyColor;
          //transition: 0.35s ease-in;

          @media #{$sm} {
            padding: 2rem 4rem 4rem;
          }

          @media #{$md} {
            height: auto;
            padding: initial;
          }
        }

        &:not(.show) {
          //transition: 0.15s ease-out;

          @media #{$md} {
            display: block;
          }
        }
      }

      .vue-slider {
        padding-left: 1rem !important;
        padding-right: 1rem !important;

        &:hover,
        &:focus {
          cursor: pointer;
        }

        @media #{$md} {
          margin-bottom: 3rem;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        @media #{$lg} {
          margin-bottom: 3.5rem;
        }

        @media #{$xl} {
          margin-bottom: 4rem;
        }
      }

      @media #{$md} {
        z-index: 1;
        bottom: auto;
        background: #fff;
        position: relative;
      }
    }
  }

  .stock-diamond-list {
    margin-bottom: 2rem;

    .empty {
      padding: 6rem 2rem 4rem;

      @media #{$sm} {
        font-size: 1.5rem;
        white-space: pre-line;
      }

      @media #{$md} {
        font-size: 2rem;
        padding-top: 6rem;
        white-space: pre-line;
      }
    }

    .show-fav {
      padding-top: 2rem;
      text-align: center;

      .btn {
        padding: 0.5rem;
        font-size: 1.1rem;
        max-width: 21rem;

        @media #{$sm} {
          font-size: 1.2rem;
        }

        @media #{$lg} {
          padding: 0.5rem 0.4rem;
        }

        @media #{$xl} {
          padding: 0.5rem;
        }
      }

      span {
        color: $realDiamondColor;
      }

      @media #{$md} {
        padding-right: 1rem;
        text-align: right;
      }
    }

    .pagination {
      &.pagination-top {
        padding: 1rem 0;
        border-bottom: 0.1rem solid $greyColor;

        .offset-1 {
          margin-left: 12.5%;
        }

        .arrow-left,
        .arrow-right {
          padding: 0;
          width: 100%;
          color: #333;
          border: none;
          background: none;
          font-size: 1.75rem;

          &:disabled {
            color: #aaa;
          }
        }
      }
    }

    .diamond-data {
      font-size: 1.2rem;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border-bottom: 0.1rem solid $greyColor;

      & > .row {
        @media #{$xxl} {
          max-width: 132rem;
          margin: auto;
        }
      }

      .img-col {
        a {
          color: #333333;
          cursor: pointer;
          font-weight: 400;
          text-decoration: none;
        }

        .carat {
          color: #fff;
          margin: 0 0 1.25rem;
          padding: 0.25rem 0;

          &.real-diamond-bg {
            background: $realDiamondColor;
          }

          &.lab-grown-bg {
            background: $labGrownColor;
          }

          @media #{$sm} {
            margin-bottom: 1.5rem;
          }

          @media #{$md} {
            margin-bottom: 0.75rem;
          }

          @media #{$lg} {
            margin-bottom: 0.5rem;
          }
        }

        img {
          display: inline-flex;
          width: 100%;
          max-width: 6.5rem;

          @media (max-width: 374px) {
            max-width: 5rem;
          }

          @media #{$sm} {
            max-width: 6.75rem;
          }

          @media #{$md} {
            max-width: 4rem;
          }

          @media #{$lg} {
            max-width: 6.5rem;
          }
        }
      }

      .data-col {
        .form,
        .purity,
        .certificate-data,
        .color,
        .finish,
        .lab-grown {
          @media #{$md} {
            padding-left: 1rem;
          }

          @media #{$lg} {
            padding-left: 2rem;
          }
        }

        p {
          padding: 0;
          margin-bottom: 0.05rem;

          span {
            &.value {
              padding-left: 0;

              a {
                font-weight: bold;

                @media #{$md} {
                  font-weight: 500;
                }
              }

              @media (max-width: 374px) {
                width: 50%;
              }
            }

            &.text {
              @media (max-width: 374px) {
                width: 50%;
              }
            }
          }

          @media #{$lg} {
            margin-bottom: 1rem;
          }
        }

        .certificate-data {
          span {
            &.value {
              @media #{$md} {
                //padding-left: 0.5rem;
              }

              @media #{$lg} {
                padding-left: 0;
              }
            }
          }
        }

        @media #{$md} {
          line-height: 1.8;
        }

        @media #{$md} {
          //line-height: 1.63;
        }
      }

      .more-col {
        font-size: 1.4rem;

        .wish-list {
          .wish-list-toggle-icon {
            cursor: pointer;
            display: inline-block;
            color: $realDiamondColor;

            &.wish-list-lab-grown {
              color: $labGrownColor;
            }
          }

          @media #{$lg} {
            text-align: right;
          }
        }

        .price {
          margin-top: 0.35rem;

          @media #{$sm} {
            margin-top: 0.8rem;
          }

          @media #{$md} {
            margin-top: 0;
          }
        }

        .more-infos {
          margin-top: 1rem;

          &.set-mt {
            margin-top: 3.35rem;

            @media (max-width: 374px) {
              margin-top: 3.55rem;
            }

            @media #{$sm} {
              margin-top: 4rem;
            }

            @media #{$md} {
              margin-top: 1rem;
            }
          }

          .btn {
            @media (max-width: 374px) {
              padding: 0.5rem;
              font-size: 1.1rem;
            }
          }

          @media (max-width: 374px) {
            margin-top: 1.55rem;
          }

          @media #{$sm} {
            margin-top: 1.25rem;
          }

          @media #{$md} {
            margin-top: 1rem;
          }

          @media #{$lg} {
            margin-top: 3.25rem;
          }
        }

        @media (max-width: 374px) {
          font-size: 1.25rem;
        }
      }

      &:nth-child(even) {
        background-color: #f0f0f0;
      }

      @media (max-width: 374px) {
        font-size: 1.15rem;
      }

      @media (min-width: 530px) {
        font-size: 1.3rem;
      }

      @media #{$sm} {
        font-size: 1.3rem;
      }

      @media #{$md} {
        font-size: 1.3rem;
      }

      @media #{$lg} {
        font-size: 1.4rem;
      }
    }

    .diamond-nav {
      border-bottom: none;

      .pagination {
        padding-top: 3rem;

        .page-item {
          .page-link {
            color: #797979;
            padding: 0.3rem 1.2rem;
            border-color: $greyColor;
            background-color: #f5f5f5;
            font-size: 1.5rem !important;
            font-weight: normal !important;

            &:hover,
            &:focus {
              cursor: pointer;
              box-shadow: none;
            }

            @media (max-width: 374px) {
              font-size: 1.3rem !important;
            }
          }

          &.disabled {
            .page-link {
              color: #d2d2d2;
              background-color: #f8f8f8;
            }
          }

          &.active {
            .page-link {
              color: #fff !important;
              font-weight: bold !important;
              border-color: $realDiamondColor;
              background-color: $realDiamondColor;
            }
          }
        }
      }
    }
  }

  &.lab-grown {
    .stock-search-filter {
      .search-accordion {
        .btn {
          &[aria-expanded="true"] {
            background-color: $labGrownColor !important;
          }
        }
      }

      .search-stock-stone-form {
        .stone-form {
          input[type="radio"] {
            &:checked + label {
              border-color: $labGrownColor;
            }
          }

          label {
            border-color: $labGrownColor;
          }
        }
      }

      .toggle-more-search {
        a {
          span {
            color: $labGrownColor;
          }
        }
      }

      .certificate-search {
        .form-check {
          .form-check-input {
            &:checked {
              border-color: $labGrownColor;
              background-color: $labGrownColor;
            }
          }
        }
      }
    }

    .stock-diamond-list {
      .show-fav {
        span {
          color: $labGrownColor;
        }
      }
    }

    .diamond-nav {
      .pagination {
        .page-item {
          &.active {
            .page-link {
              border-color: $labGrownColor;
              background-color: $labGrownColor;
            }
          }
        }
      }
    }
  }
}
</style>
